<div class="container-fluid">
  <div class="row">
    <div class="d-flex p-lg-2 p-md-2 pl-xs-8 justify-content-between align-items-center top-nav">
      <div class="col-lg-3 col-sm-3 col-md-3 col-xs-3 col-white d-flex align-items-center">
        <div class="margin-right cursor-pointer" (click)="checkVersionInfo()" matTooltip="Reisekosten App">Reisekosten App v2.7.16</div>
        <div class="d-flex align-items-center justify-content-between cursor-pointer" (click)="goToDashboard()"><mat-icon class="home-icon" matTooltip="Home">home</mat-icon></div>
      </div>
      <div class="col-lg-3 col-sm-3 col-md-3 col-xs-3 d-flex align-items-center justify-content-center">
        <div *ngIf="rolSelected === 'bookeeper'">
          <div class="role-show" *hasRole="[userRole.BOOKEEPER]">Eingeloggt als: Buchhaltung</div>
        </div>
        <div *ngIf="rolSelected === 'employee'">
          <div class="role-show" *hasRole="[userRole.BOOKEEPER]">Eingeloggt als: Mitarbeiter</div>
        </div>
        <!-- <div class="text-white" *hasRole="[userRole.BOOKEEPER]">Ansicht wechseln</div> -->
       <div class="marg-icon" *hasRole="[userRole.BOOKEEPER]" (click)="openBookeeperModal()">
        <mat-icon class="swap-role" matTooltip="Ansicht wechseln"><span class="material-symbols-outlined">swap_vert</span></mat-icon>
      </div>
      </div>
      <div class="d-flex col-lg-4 col-sm-3 col-md-4 col-xs-4 justify-content-end align-items-center">
       <!-- <mat-icon aria-hidden="false" aria-label="search icon" fontIcon="notifications_none" class="bell-icon" ></mat-icon> routerLink="/employeeprofile"-->
       <button
        class="notification-button"
        mat-icon-button
        [matMenuTriggerFor]="notificationMenu"
        aria-label="Notification icon-button with a menu"
        matTooltip="Benachrichtigungen"
        #notificationMenuTrigger="matMenuTrigger"
        (click)="clearUnseenCount()"
      >
        <mat-icon
          *ngIf="this.unseenCount > 0"
          class="notification-icon"
          matBadge="{{ this.unseenCount }}"
          matBadgeColor="warn"
          aria-hidden="false"
          >notifications</mat-icon
        >
        <mat-icon *ngIf="this.unseenCount === 0" class="notification-icon"
          >notifications</mat-icon
        >
      </button>
      <mat-menu
        class="notification-menu"
        #notificationMenu="matMenu"
        xPosition="before"
      >
        <app-notification [roleChanged]="rolSelected" [menuOpened]="reload"></app-notification>
      </mat-menu>
      <!-- <mat-icon aria-hidden="false" aria-label="search icon" fontIcon="account_circle" class="account"></mat-icon> -->
       <div class="text-white mr-3">Welcome, {{userName}}</div>
       <div class="profile-picture">
        <img *ngIf="profilePicUrl" [src]="profilePicUrl" alt="{{userName}}" />
        <mat-icon *ngIf="!profilePicUrl" aria-hidden="false" aria-label="search icon" fontIcon="account_circle" class="account no-profile">account</mat-icon>
      </div>
       <div class="col-sm-2 text-center log-out" (click)="logout()" matTooltip="Log Out"><span class="material-icons-outlined">
        logout
        </span></div>
      </div>
    </div>
  </div>
</div>



